import { Tool } from './Tool';

export class BoxTool extends Tool {
	constructor(options) {
		super({
			...options,
			cursor: 'crosshair'
		});
	}

	onActived() {
		/** @type {[number, number]} */
		this.p1 = null;

		/** @type {[number, number]} */
		this.p2 = null;
	}

	onInput({ type, x, y }) {
		let commit = false;
		switch (type) {
			case 'mousedown': this.p1 = [x, y]; break;
			case 'mousemove': this.p2 = [x, y]; break;
			case 'mouseup': commit = true;
		}
		const drawing = this.generate();
		if (commit) {
			this.p1 = null;
			this.p2 = null;
		}
		return { commit, drawing };
	}

	generate() {
		const { p1, p2, mode } = this;
		if (!p1 || !p2) {
			return null;
		}

		const [x1, y1] = p1;
		const [x2, y2] = p2;
		const x = Math.min(x1, x2);
		const y = Math.min(y1, y2);
		const width = Math.abs(x1 - x2);
		const height = Math.abs(y1 - y2);
		const drawing = { type: mode, param: [x, y, width, height, x1, x2, y1, y2] };

		return drawing;
	}

	onDeactivated() {
		// do not output on deactived
		return { commit: false, drawing: null };
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/BoxTool.js